/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { IoMdClose } from 'react-icons/io';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import 'swiper/css';
import 'swiper/css/pagination';
import useBanner from '../../hooks/useBanner';

const PromoModal = () => {
  const { banners } = useBanner();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (banners.length > 0) {
      setOpen(true);
    }
  }, [banners]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      disableEnforceFocus
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60%',
          bgcolor: 'white',
          borderRadius: 2,
          boxShadow: 24,
          p: 2,
        }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IoMdClose
            size={24}
            style={{ cursor: 'pointer' }}
            onClick={handleClose}
          />
        </div>
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={banners.length > 1}
          pagination={{ clickable: true }}
          style={{
            background: 'transparent',
          }}>
          {banners.map(banner => (
            <SwiperSlide key={banner.id}>
              <div
                className="home_item_box_pic_bg"
                style={{
                  background: `url(${banner?.picLink})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                }}>
                <div className="home_item_box_pic_text_box">
                  <div className="home_item_box_pic_header">{banner.title}</div>
                  <div className="home_item_box_pic_more">
                    {banner?.details}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Modal>
  );
};

export default PromoModal;
